// extracted by mini-css-extract-plugin
export var callout = "about-sidecallout-module--callout--v9itQ";
export var callout_text = "about-sidecallout-module--callout_text--gT9eG";
export var hero = "about-sidecallout-module--hero--gV4lm";
export var root = "about-sidecallout-module--root--cSIBI";